import { catchError, defer, forkJoin, from, map, of, retry, switchMap, tap, timeout } from 'rxjs';

/**
 * this function should:
 * - split input assets list by shard;
 * - start loading every pool in parallel;
 * - every pool items should be loaded sequentially;
 * @param creative
 * @param createFactory
 */
export function preloadAssetsShardSequentially(creative, createFactory){
  const assets = creative.assets;
  const totalAssets = assets.length;
  // Create an array of asset shards
  const shards = new Map();
  for (let i = 0; i < totalAssets; i++) {
    const asset = assets[i];
    const shard = asset.split('.vcdn')[0].substr(-2);
    if (!shards.has(shard)) {
      shards.set(shard, []);
    }
    shards.get(shard).push(asset);
  }

  // Function to preload a single shard sequentially
  const preloadShardSequentially = (shard, index = 0) => {
    if (index >= shard.length) {
      return of(shard);
    }
    const url = shard[index];
    const factory = createFactory(url);
    return defer(factory).pipe(
      retry({
        count: 2,
        delay: 2_000,
      }),
      timeout({
        first: 10_000,
        with: () => {
          throw new Error('Preload asset timeout');
        },
      }),
      catchError((error) => {
        error.url = url;
        return of(error);
      }),
      switchMap((result) => {
        if (result instanceof Error) {
          throw result;
        }
        return preloadShardSequentially(shard, index + 1);
      }),
    );
  };

  const loaders = Array.from(shards.values()).map(
    (shard) => preloadShardSequentially(shard)
  );
  return from(forkJoin(loaders)).pipe(
    tap((results) => {
      const errors = results.flat().filter((result) => result instanceof Error);
      if (errors.length) {
        throw errors;
      }
    }),
    map(() => creative),
  );
}

